import {
  camelCase,
  groupBy,
  map,
  result,
  trim,
  zipObject
} from 'libraries/lodash'
import { toJson } from 'front-end-core/helpers/xml'
import linkify from 'linkifyjs/html'
import dayjs from 'dayjs'
import { DATE_FORMAT, DATE_WITH_LONG_MONTH } from 'constants/locale'
import { parseJson, sortKeys } from 'helpers/transforms'

export const toCurrentAwareness = function (data) {
  const toContentSection = function (cs, i) {
    const {
      title,
      text = '',
      barristersComment = null,
      barristersHeading = null,
      fcContent = null,
      position = null,
      trimmed = null
    } = zipObject(
      map(cs.childNodes, 'name').map(camelCase),
      map(cs.childNodes, 'content').map(trim)
    )
    const contentText = linkify(
      text.replace(
        /FC Content:(.*)/g,
        '<div class="ca-fc-content"><strong>FC Content:</strong> $1</div>'
      )
    )

    const content = []
    const barristersBox = barristersHeading || barristersComment

    barristersBox && content.push('<div class="ca-barristers-comment">')
    barristersHeading &&
      content.push(`<div class="heading">${barristersHeading}</div>`)
    barristersComment &&
      content.push(`<div class="body">${barristersComment}</div>`)
    barristersBox && content.push('</div>')
    contentText && content.push(`<div class="ca-content">${contentText}</div>`)
    fcContent && content.push(`<div class="ca-fc-content">${fcContent}</div>`)

    return {
      content: content.join(''),
      date: dayjs(cs.attributes.date).format(DATE_FORMAT),
      id: cs.attributes.id || Math.ceil(Math.random() * 10000000).toString(16),
      number: String(i + 1),
      title,
      position,
      trimmed,
      imageUrl: cs.attributes.imageUrl
    }
  }

  return sortKeys(
    groupBy(
      result(
        toJson(data, [
          'ContentSections',
          'ContentSection',
          'title',
          'Text',
          'barristers-comment',
          'barristers-heading',
          'fc-content',
          'position',
          'trimmed'
        ]),
        '0.childNodes',
        []
      ).map(toContentSection),
      'date'
    )
  )
}

export const toGuides = function (data) {
  data = parseJson(data)
  const guideList = {}
  const guides = []
  data.forEach(item => {
    const id = Math.floor(Math.random() * 10000)
    const datePublished = dayjs(dayjs(item.datePublished, DATE_WITH_LONG_MONTH)).format(DATE_FORMAT)
    const dateLastUpdated = dayjs(dayjs(item.dateLastUpdated, DATE_WITH_LONG_MONTH)).format(
      DATE_FORMAT
    )
    const link = item.isPublic ? '../static/' + item.fileName : 'static/' + item.fileName
    guideList[id] = Object.assign({}, item, {
      datePublished,
      dateLastUpdated,
      link,
      id
    })
    guides.push(id)
  })
  return {
    guides,
    guideList
  }
}

export const toContentFolders = function (data) {
  data = parseJson(data)

  const folders = {}
  const rootLevel = []

  const analyzeFolder = (path, depth = 0) => ({ children, documents, name, uuid }) => {
    folders[uuid] = {
      uuid,
      name,
      documents,
      documentCount: documents.length,
      children: () => children.map(({ uuid }) => folders[uuid]),
      path: [...path, uuid],
      depth
    }

    path.forEach(ancestorUuid => { folders[ancestorUuid].documentCount += documents.length })
    children.forEach(analyzeFolder([...path, uuid], depth + 1))
    !path.length && rootLevel.push(folders[uuid])
  }
  data.forEach(analyzeFolder([]))

  return { folders, rootLevel }
}

export const toCurrentAwarenessSearchResults = function (data) {
  data = parseJson(data).data

  return {
    resultCount: data.total,
    results: data.articles.map(r => ({
      id: r.id,
      title: r.title || null,
      content: r.snippets,
      dateOfPublication: r.dateOfPublication
    }))
  }
}

export const toPublishedCaKeyPicks = (data) => {
  const keyPicks = parseJson(data)
  return keyPicks
}
